/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useEffect, useState } from "react";
import { throttle } from "underscore";

import Toolbar from "@material-ui/core/Toolbar";
import ToolbarButton from "./ToolbarButton";

import Slider from "@material-ui/core/Slider";

import "../constants/toolbars";

import Typography from "@material-ui/core/Typography";
// import theme from "../config/theme";

import FullscreenIcon from "@material-ui/icons/Fullscreen";
import FullscreenExitIcon from "@material-ui/icons/FullscreenExit";

import ZoomInIcon from "@material-ui/icons/ZoomIn";
import ZoomOutIcon from "@material-ui/icons/ZoomOut";

import FitIcon from "@material-ui/icons/CenterFocusWeak";

import { useStoreon } from "storeon/react";

import UndoIcon from "@material-ui/icons/Undo";
import RedoIcon from "@material-ui/icons/Redo";

import History from "./tools/History";

import t from "../translations";
import { useCanvasZoom } from "utils/canvas";

import { navigationBar } from "externalData";

const Navigation = () => {
  const { canvas } = useStoreon("canvas");
  const [isFullscreen, setIsFullscreen] = useState(false);
  const { current, min, max, full, step } = useCanvasZoom();

  const fullscreenToggle = function _toggleFullScreen() {
    if (
      document.fullscreenElement ||
      document.mozFullScreenElement ||
      document.webkitFullscreenElement
    ) {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else {
        if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else {
          if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          }
        }
      }
    } else {
      const _element = document.documentElement;
      if (_element.requestFullscreen) {
        _element.requestFullscreen();
      } else {
        if (_element.mozRequestFullScreen) {
          _element.mozRequestFullScreen();
        } else {
          if (_element.webkitRequestFullscreen) {
            _element.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
          }
        }
      }
    }
  };

  useEffect(() => {
    const handleStatusChange = () => {
      if (document.fullscreenElement) {
        setIsFullscreen(true);
      } else {
        setIsFullscreen(false);
      }
    };
    document.onfullscreenchange = handleStatusChange;
  }, []);

  const setCanvasZoomRaw = (zoom) => {
    canvas.zoomToPoint({ x: canvas.width / 2, y: canvas.height / 2 }, zoom);
    canvas.fire("canvas:viewport");
    canvas.fire("canvas:zoom");
  };

  const setCanvasZoom = throttle(setCanvasZoomRaw, 16);

  const handleSliderChange = (e, val) => {
    setCanvasZoom(val);
  };

  if (!canvas) return null;

  return (
    <Toolbar
      variant="dense"
      css={css`
        min-height: 24px;
        display: flex;
        justify-content: center;

        .privacyurls {
          > a {
            color: white;
            margin-right: 5px;
          }
        }
        @media screen and (max-width: 480px) {
          padding: 0px 4px;
          > button {
            min-width: 34px;
            background: none;
          }
          > div.deskpad-history {
            display: none;
          }
          .privacyurls {
            display: none;
          }
        }
      `}
    >
      <ToolbarButton
        height={36}
        width={48}
        tooltip
        dark
        active={isFullscreen}
        onClick={fullscreenToggle}
        desc={isFullscreen ? t.exit : t.fullscreen}
        icon={isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
      />
      <ToolbarButton
        height={36}
        width={48}
        tooltip
        dark
        desc={t.fitCanvas}
        icon={<FitIcon />}
        onClick={(e) => {
          canvas.DPE.cutZone.fitCutZone();
        }}
      />
      <ToolbarButton
        height={36}
        width={48}
        tooltip
        dark
        desc={t.zoomOut}
        icon={<ZoomOutIcon />}
        onClick={(e) => {
          if (current - step < min) {
            setCanvasZoom(min);
            return;
          }
          setCanvasZoom(current - step);
        }}
      />

      <Slider
        min={min}
        max={max}
        step={step}
        value={current}
        onChange={handleSliderChange}
        css={css`
          max-width: 250px;
          button {
            width: 18px;
            height: 18px;
            background: #fff;
          }
          > div > div {
            background: #fff !important;
          }
        `}
      />
      <ToolbarButton
        height={36}
        width={48}
        tooltip
        dark
        desc={t.zoomIn}
        icon={<ZoomInIcon />}
        onClick={(e) => {
          if (current + step > max) {
            setCanvasZoom(max);
            return;
          }
          setCanvasZoom(current + step);
        }}
      />
      <Typography style={{ color: "white" }}>
        {((current / full) * 100).toFixed(0)}%
      </Typography>
      <ToolbarButton
        height={36}
        width={48}
        tooltip
        dark
        desc={t.undo}
        icon={<UndoIcon />}
        onClick={(e) => {
          canvas.DPE.history.undo();
        }}
      />

      <ToolbarButton
        height={36}
        width={48}
        tooltip
        dark
        desc={t.redo}
        icon={<RedoIcon />}
        onClick={(e) => {
          canvas.DPE.history.redo();
        }}
      />
      <History />
      <div
        className="privacyurls"
        dangerouslySetInnerHTML={{ __html: navigationBar }}
      ></div>
    </Toolbar>
  );
};

export default Navigation;
